import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { debounce } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "InactiveActions",
  props: {
    searchString: {
      type: String,
      default: ""
    }
  },
  computed: {
    searchClient: {
      get() {
        return this.searchString;
      },
      set: debounce(function (text) {
        if (text.length && _trimInstanceProperty(text).call(text).length <= 2) return;
        this.$emit("inactive-search", _trimInstanceProperty(text).call(text));
      }, 250)
    }
  }
});